import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const BrakesIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M12.72 20.74C10.22 20.74 7.94 19.68 6.32 17.98L5.36 18.94C3.5 17.08 2.44 14.6 2.44 11.96C2.44 9.32 3.5 6.84 5.36 4.98L6.32 5.94C7.94 4.24 10.22 3.18 12.72 3.18C17.54 3.18 21.54 7.16 21.54 11.96C21.54 16.76 17.54 20.74 12.72 20.74ZM12.72 4.98C8.92 4.98 5.78 8.14 5.78 11.96C5.78 15.78 8.92 18.94 12.72 18.94C16.52 18.94 19.66 15.78 19.66 11.96C19.66 8.14 16.52 4.98 12.72 4.98ZM12.72 14.6C11.3 14.6 10.08 13.38 10.08 11.96C10.08 10.54 11.3 9.32 12.72 9.32C14.14 9.32 15.36 10.54 15.36 11.96C15.36 13.38 14.14 14.6 12.72 14.6Z" />
    </SvgIcon>
  );
});
